import { i18n } from "../pages/private/languageSelector";
import SubscriptionCustomToast from "../components/dialogs/SubscriptionCustomToast";

// export const notificationAlert = (payload, currentRole, user) => {
//   if (
//     payload &&
//     payload?.event === "assigned" &&
//     payload?.senderId !== user?.id
//   ) {
//     SubscriptionCustomToast(i18n("global.YouHaveNewAssignForm"));
//   } else if (payload && payload?.event === "approved") {
//     // SubscriptionCustomToast(i18n("global.YourReportIsApproved"));
//   } else if (payload && payload?.event === "rejected") {
//     // SubscriptionCustomToast(i18n("global.YourReportIsRejected"));
//   } else if (payload && payload?.event === "submit") {
//     SubscriptionCustomToast(i18n("global.NewReportReceived"));
//   } else if (payload && payload?.event === "reSubmit") {
//     SubscriptionCustomToast(i18n("global.ReSubmitReportReceived"));
//   } else if (payload && payload?.event === "incomplete") {
//     // SubscriptionCustomToast(i18n("global.YourReportIsIncompleted"));
//   } else if (
//     payload &&
//     payload?.event === "roleUpdate" &&
//     currentRole === "user"
//   ) {
//     SubscriptionCustomToast(i18n("global.YourRoleUpdated"));
//   }
// };

export const notificationAlert = (payload, currentRole, user) => {
  if (
    payload &&
    payload?.event === "assigned" &&
    payload?.senderId !== user?.id
  ) {
    SubscriptionCustomToast(i18n("global.YouHaveNewAssignForm"));
  } else if (payload && payload?.event === "submit") {
    SubscriptionCustomToast(i18n("global.NewReportReceived"));
  } else if (payload && payload?.event === "reSubmit") {
    SubscriptionCustomToast(i18n("global.ReSubmitReportReceived"));
  } else if (
    payload &&
    payload?.event === "roleUpdate" &&
    currentRole === "user"
  ) {
    SubscriptionCustomToast(i18n("global.YourRoleUpdated"));
  }
};
